var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "list-dnt" } },
    [
      [
        _vm.view === "entrada"
          ? _c(
              "div",
              { staticClass: "d-flex mb-3" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "outline-primary",
                      size: "sm",
                      "data-cy": "sign-documents"
                    },
                    on: {
                      click: function($event) {
                        return _vm.searchMassiveSign()
                      }
                    }
                  },
                  [_vm._v(" Quiero firmar varios documentos ")]
                ),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-between ml-3" },
                  [
                    _vm.showCheck && _vm.orderTrays.length
                      ? _c(
                          "div",
                          [
                            _c("b-form-checkbox", {
                              staticClass: "d-inline-block",
                              attrs: { "data-cy": "select-all" },
                              on: {
                                change: function($event) {
                                  return _vm.selectAllFlows()
                                }
                              },
                              model: {
                                value: _vm.selectAll,
                                callback: function($$v) {
                                  _vm.selectAll = $$v
                                },
                                expression: "selectAll"
                              }
                            }),
                            _vm._v(" Seleccionar todos ")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedFlows.length && _vm.filteredUserSigns.length
                      ? _c(
                          "b-button",
                          {
                            staticClass: "ml-3",
                            attrs: {
                              variant: "primary",
                              size: "sm",
                              "data-cy": "sign-all-flows"
                            },
                            on: {
                              click: function($event) {
                                return _vm.signAllFlows()
                              }
                            }
                          },
                          [_vm._v(" Firmar ")]
                        )
                      : _vm._e(),
                    _vm.selectedFlows.length && !_vm.filteredUserSigns.length
                      ? _c(
                          "b-button",
                          {
                            staticClass: "ml-3",
                            attrs: {
                              variant: "warning",
                              size: "sm",
                              "data-cy": "cant-sign"
                            }
                          },
                          [
                            _vm._v(
                              " Firmas habilitadas no soportan esta acción "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ],
      _vm.view === "general"
        ? _c(
            "div",
            { staticClass: "d-flex search-bar mb-2" },
            [
              _c("vs-input", {
                staticClass: "mt-2 w-100",
                attrs: {
                  "icon-after": "true",
                  size: "small",
                  "label-placeholder": "icon-after",
                  icon: "mode_edit",
                  placeholder: "Buscar coincidencias",
                  "data-cy": "search"
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.fetchDocuments()
                  }
                },
                model: {
                  value: _vm.textSearch,
                  callback: function($$v) {
                    _vm.textSearch = $$v
                  },
                  expression: "textSearch"
                }
              }),
              _vm.searchParam
                ? _c("vs-button", {
                    staticClass: "ml-3",
                    attrs: {
                      radius: "",
                      color: "primary",
                      type: "border",
                      icon: "highlight_off",
                      size: "small"
                    },
                    on: {
                      click: function($event) {
                        return _vm.clearSearch()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("TraysFilters", {
        attrs: {
          value: _vm.filters,
          onChange: _vm.onChangeFilters,
          clear: _vm.clearFilters
        }
      }),
      _c("hr"),
      _c("FilesHeader"),
      _c(
        "div",
        { key: _vm.forceRender, staticClass: "force-render" },
        _vm._l(_vm.orderTrays, function(file) {
          return _c("FileRow", {
            key: file.aprobacionId,
            attrs: {
              file: file,
              process: "sign",
              "show-check": _vm.showCheck,
              blockedProcess: _vm.blockedProcess,
              "select-file": _vm.selectFile,
              "data-cy": "file"
            },
            on: {
              "select-flow": _vm.selectFlow,
              "unselect-flow": _vm.unSelectFlow
            }
          })
        }),
        1
      ),
      _c("FilesPagination", {
        attrs: { show: _vm.trays.length },
        model: {
          value: _vm.page,
          callback: function($$v) {
            _vm.page = $$v
          },
          expression: "page"
        }
      }),
      _c(
        "b-modal",
        {
          ref: "process",
          attrs: {
            title: "Firmar documentos",
            "hide-footer": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("ModalSignProcess", {
            attrs: { "selected-flows": _vm.selectedFlows, process: "sign" },
            on: { "close-modal": _vm.closeModal }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }